import { useState } from 'react';

import { BadgeName } from 'components/badges/badge-name';
import { T } from 'components/translation';

import { ExportModalBase } from '.';
import { TooManyRequests } from './helpers/too-many-requests';

type Props = {
  onExport: (onSuccess: () => void) => void,
  email: string,
}

export const ExportUsersModal = ({ onExport, email }: Props) => {
  const [errorStatusCode, setErrorStatusCode] = useState<number | undefined>(undefined);

  const renderBody = () => {
    return (
      <>
        <p>
          <T
            _str="The export will include general info about all users, including their roles and permissions in this account."
            _comment="Modal body text explaining what the export will include."
          />
        </p>
        <p>
          <T
            _str="The download link will be sent to {userEmail} shortly."
            userEmail={<BadgeName>{email}</BadgeName>}
            _comment="Help text explaining where the email will be sent in the export modal."
          />
        </p>
        <TooManyRequests errorStatusCode={errorStatusCode} />
      </>
    );
  };

  return (
    <ExportModalBase
      tooltip={(
        <T
          _str="Export user list and permissions reports"
          _comment="Tooltip text explaining what the export button is for."
        />
      )}
      header={(
        <T
          _str="Export users"
          _comment="Confirm modal title for exporting users."
        />
      )}
      onExport={onExport}
      renderBody={renderBody}
      setErrorStatusCode={setErrorStatusCode}
      disabled={false}
    />
  );
};
